<template>
  <div>
    <modal :show.sync="publicPage" ref="publicPageModalRef" headerClasses="justify-content-center" class="modal-public-page" type="custom" :scrollToBottom="false" modalClasses="modal-dialog-scrollable" v-on:hideModal="hideModal">
      <h4 slot="header" class="title title-up">{{ $t('settings.titlePPage') }}</h4>
      <template slot="close-button">
        <button type="button" class="close" @click='hideModal()' data-dismiss="modal" aria-label="Close"><i class="tim-icons icon-simple-remove"></i></button>
      </template>
      <div class="row public-page-container">
        <div class="row row-pbttom" >
          <label class="col-sm-12 col-md-12 col-lg-12 ppage-label" >{{ $t('settings.rangePPage') }}</label>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <base-input name="date">
              <el-date-picker
                type="datetimerange"
                value-format="timestamp"
                @change="onChangeDate"
                range-separator="-"
                format="yyyy-MM-dd HH:mm"
                lang="fr"
                v-bind:start-placeholder="$t('projectForm.labelProjectStart')"
                v-bind:end-placeholder="$t('projectForm.labelProjectEnd')"
                v-model="urlParams.date">
              </el-date-picker>
            </base-input>
          </div>
        </div>
        <div class="row row-pbttom">
          <label class="col-sm-12 col-md-12 col-lg-12 ppage-label" >{{ $t('settings.typeMapPPage') }}</label>
          <div class="col-sm-12 col-md-12 col-lg-12">
            <div class="row map-image-container map-image-box">
              <div class="col-sm-3 col-md-3 col-lg-3 map-image-content" v-bind:key="item.key" v-for="item in maps" :class="[ { selected: item.active }]" @click="changeMap(item);">
                <img :src="item.fname">
                <label>{{item.label}}</label>
              </div>
            </div>
          </div>
        </div>
        <div class="row theme-row">
          <label class="col-sm-12 col-md-12 col-lg-12 ppage-label">{{ $t('settings.title') }}</label>
          <div style="display:contents" class="col-sm-12 col-md-12 col-lg-12">
            <div style="display:grid;" class="col-sm-3 col-md-3 col-lg-3">
              <span class="label-switch">{{ $t('settings.entraves') }} </span>
              <base-switch v-model="display.entraves" @input="changeDisplay"></base-switch>
            </div>
            <div style="display:grid;" class="col-sm-3 col-md-3 col-lg-3">
              <span class="label-switch">{{ $t('settings.closing') }} </span>
              <base-switch v-model="display.closing" @input="changeDisplay"></base-switch>
            </div>
            <div style="display:grid;" class="col-sm-3 col-md-3 col-lg-3">
              <span class="label-switch">{{ $t('settings.detour') }} </span>
              <base-switch v-model="display.detours" @input="changeDisplay"></base-switch>
            </div>
          </div>
        </div>
        <!-- Embed as iFrame section (body) -->
        <div v-if="!!features.embedIframeOnPublicPage && features.embedIframeOnPublicPage.show" class="row embed-body-section">
          <div class="col-12">
            <div class="embed-section-body">
              <button class="btn btn-embed-toggle" @click="toggleEmbedPanel">
                <i class="tim-icons icon-code-editor"></i>
                {{ showEmbedPanel ? 'Hide Embed Code' : 'Embed as iFrame' }}
              </button>

              <!-- Embed panel -->
              <transition name="embed-slide">
                <div v-if="showEmbedPanel" class="embed-panel">
                  <p class="embed-hint">Enter the width and height for the embedded map, then choose the unit.</p>
                  <div class="embed-inputs">
                    <!-- Width -->
                    <div class="embed-input-group">
                      <label class="embed-label">Width</label>
                      <div class="embed-input-row">
                        <input
                          v-model="embedSize.widthValue"
                          type="number"
                          min="1"
                          class="form-control embed-input"
                          placeholder="100"
                        />
                        <select v-model="embedSize.widthUnit" class="embed-unit-select">
                          <option value="%">%</option>
                          <option value="px">px</option>
                        </select>
                      </div>
                    </div>
                    <!-- Height -->
                    <div class="embed-input-group">
                      <label class="embed-label">Height</label>
                      <div class="embed-input-row">
                        <input
                          v-model="embedSize.heightValue"
                          type="number"
                          min="1"
                          class="form-control embed-input"
                          placeholder="100"
                        />
                        <select v-model="embedSize.heightUnit" class="embed-unit-select">
                          <option value="%">%</option>
                          <option value="px">px</option>
                        </select>
                      </div>
                    </div>
                    <button class="btn btn-primary btn-generate" @click="generateIframeCode">
                      <i class="tim-icons icon-settings"></i> Generate
                    </button>
                  </div>

                  <!-- Generated code -->
                  <transition name="embed-slide">
                    <div v-if="iframeCode" class="iframe-result">
                      <label class="embed-label">Copy this code and paste it anywhere:</label>
                      <div class="iframe-code-block">
                        <pre class="iframe-code">{{ iframeCode }}</pre>
                        <button class="btn btn-copy" :class="{ copied: iframeCopied }" @click="copyIframeCode">
                          <i class="tim-icons" :class="iframeCopied ? 'icon-check-2' : 'icon-single-copy-04'"></i>
                          {{ iframeCopied ? 'Copied!' : 'Copy' }}
                        </button>
                      </div>
                    </div>
                  </transition>
                </div>
              </transition>
            </div>
          </div>
        </div>
      </div>
      <!-- Footer: original single link -->
      <template slot="footer">
        <div role="alert" class="alert alert-info alert-with-icon">
          <span data-notify="message">
            <a :href="url" target="_blank" class="url-link">{{ $t('settings.clickPPage') }}</a>
            <input id="public-link" type="text" :value="url" class="inputHidden" />
            <!--<i class="tim-icons icon-single-copy-04 icon-copy" @click="copyLink();"></i>-->
          </span>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
  
import { Modal } from 'src/components';
import { TabPane, Tabs, BaseSwitch } from 'src/components';
import { Select, Option, TimeSelect, DatePicker } from 'element-ui';
import features from './../shared/features';

export default {
  name:'public-page',
  props: ['publicPage'],
  components: {
    Modal,
    TabPane,
    Tabs,
    BaseSwitch,
    [Option.name]: Option,
    [Select.name]: Select,
    [DatePicker.name]: DatePicker,
    [TimeSelect.name]: TimeSelect
  },
  watch: {
    'publicPage'(){
      if (this.publicPage) {
        this.generateUrl();
      }
    }
  },
  data() {
    return {
      instance:null,
      typeMap: 'streets',
      modeMap: "0",
      display: {
        'entraves': true,
        'closing': true,
        'detours': true
      },
      maps: [
        { active: true,  modeMap: '0', key:'osm', label: 'OpenStreetMap', fname: 'static/img/map/osm.jpg' },
        { active: false, modeMap: '0', key:'streets', label: 'Streets', fname: 'static/img/map/streets.jpg' },
        { active: false, modeMap: '0', key:'topo', label: 'Topographic', fname: 'static/img/map/topo.jpg' },
        { active: false, modeMap: '0', key:'dark-gray', label: 'Dark Gray Canvas', fname: 'static/img/map/dark_gray_canvas.png' },
        { active: false, modeMap: '0', key:'gray', label: 'Light Gray Canvas', fname: 'static/img/map/light_gray_canvas.jpg' },
        { active: false, modeMap: '0', key:'satellite', label: 'Imagery', fname: 'static/img/map/imagery.jpg' },
        // { active: false, modeMap: '1', key:'28f49811a6974659988fd279de5ce39f', label: 'Imagery Hybrid', fname: 'static/img/map/imagery.jpg' },
        { active: false, modeMap: '0', key:'national-geographic', label: 'National Geographic', fname: 'static/img/map/nat_geo.jpg' },
        { active: false, modeMap: '0', key:'terrain', label: 'Terrain with Labels', fname: 'static/img/map/terrain_labels.jpg' },
        { active: false, modeMap: '1', key:'098132d21c014e62908d847e3b74d740', label: 'Dark Grey-Community Map of Canada', fname: 'static/img/map/dark_grey_canada.jpeg' },
        { active: false, modeMap: '1', key:'e1de1cfd7a624639b65e2cc0f10aad70', label: 'Light Grey-Community Map of Canada', fname: 'static/img/map/light_grey_canada.jpeg' },
        { active: false, modeMap: '1', key:'41fff870ffc2461ab79cd949da2ac1bc', label: 'Streets (Night)-Community Map of Canada', fname: 'static/img/map/streets_night_canada.png' },
        { active: false, modeMap: '1', key:'cba1e859423a424eb26fb73c5df5ecdf', label: 'Streets-Community Map of Canada', fname: 'static/img/map/streets_canada.png' },
        { active: false, modeMap: '1', key:'98652eb8458a464fa95feb9bd812b29a', label: 'Topographic-Community Map of Canada', fname: 'static/img/map/topographic_canada.jpeg' }
      ],
      urlParams: {
        date: [new Date().getTime() - (6*30*24*60*60*1000), new Date().getTime() + (6*30*24*60*60*1000)],
        published: true,
        typeMap: 'osm',
        modeMap: '0'
      },
      url: '',
      features: [],
      city: null,
      showEmbedPanel: false,
      embedSize: {
        widthValue: '100',
        widthUnit: '%',
        heightValue: '100',
        heightUnit: '%'
      },
      iframeCode: '',
      iframeCopied: false
    };
  },
  mounted() {
    this.instance = JSON.parse(window.localStorage.getItem('instance'));
    this.city = this.instance.city;
    this.features = features[this.city];
    if (this.city === 'guelph') {
      this.maps = [
        { active: true, modeMap: '0', key:'gray', label: 'Light Gray Canvas', fname: 'static/img/map/light_gray_canvas.jpg' },
        { active: false, modeMap: '1', key:'e1de1cfd7a624639b65e2cc0f10aad70', label: 'Light Grey-Community Map of Canada', fname: 'static/img/map/light_grey_canada.jpeg' }
      ];
      this.urlParams.typeMap = 'gray';
      this.urlParams.modeMap = '0';
      this.typeMap = 'gray';
      this.modeMap = '0';
    } else if (this.city === 'sjsr') {
      this.maps.push({ active: false, modeMap: '2', key:'92c9dbcdd3ba4b95a07c2116c7b1cb09', label: 'SJSR Custom basemap', fname: 'static/img/map/sjsr.png' });
    }
  },
  methods: {
    hideModal() {
      this.maps.forEach(listItem => {
        listItem.active = false;
      });
      this.maps[0].active=true;
      this.urlParams = {
        date: [new Date().getTime() - (6*30*24*60*60*1000), new Date().getTime() + (6*30*24*60*60*1000)],
        published: true,
        typeMap: this.city === 'guelph' ? 'gray' : 'osm',
        modeMap: '0'
      };
      this.$emit('hidePublicPage');
    },
    changeMap(item) {
      this.maps.forEach(listItem => {
        listItem.active = false;
      });
      item.active=true;
      this.urlParams.typeMap=item.key;
      this.urlParams.modeMap=item.modeMap;
      this.generateUrl();
    },
    changeDisplay() {
      this.generateUrl();
    },
    generateUrl() {
      let user = JSON.parse(window.localStorage.getItem('user'));
      let lang = user.lang || 'fr';
      let url = 'https://' + window.location.host + '/#/public?city=' + this.instance.city + 
                '&long=' + this.instance.center.long + 
                '&lat=' + this.instance.center.lat + 
                '&type=' + this.urlParams.typeMap +
                '&modeMap=' + this.urlParams.modeMap +
                '&entraves=' + this.display.entraves +
                '&closing=' + this.display.closing +
                '&detours=' + this.display.detours +
                '&lang=' + lang + 
                '&sdate=' + this.urlParams.date[0]+ 
                '&edate=' + this.urlParams.date[1];
      this.url = url;
    },
    onChangeDate() {
      this.generateUrl();
    },
    copyLink() {
      let copyText = document.querySelector("#public-link");
      copyText.select();
      document.execCommand("copy");
    },
    toggleEmbedPanel() {
      this.showEmbedPanel = !this.showEmbedPanel;
      if (!this.showEmbedPanel) {
        this.iframeCode = '';
        this.iframeCopied = false;
      }
    },
    generateIframeCode() {
      const w = (this.embedSize.widthValue || '100') + this.embedSize.widthUnit;
      const h = (this.embedSize.heightValue || '100') + this.embedSize.heightUnit;
      this.iframeCode = `<iframe\n  src="${this.url}"\n  width="${w}"\n  height="${h}"\n  frameborder="0"\n  allowfullscreen\n  style="border:none;">\n</iframe>`;
      this.iframeCopied = false;
    },
    copyIframeCode() {
      if (!this.iframeCode) return;
      if (navigator.clipboard) {
        navigator.clipboard.writeText(this.iframeCode).then(() => {
          this.iframeCopied = true;
          setTimeout(() => { this.iframeCopied = false; }, 2000);
        });
      } else {
        // Fallback for older browsers
        const el = document.createElement('textarea');
        el.value = this.iframeCode;
        document.body.appendChild(el);
        el.select();
        document.execCommand('copy');
        document.body.removeChild(el);
        this.iframeCopied = true;
        setTimeout(() => { this.iframeCopied = false; }, 2000);
      }
    }
  }
}
</script>
<style>
  div.public-page-container {
    margin: 30px;
  }
  div.public-page-container label.ppage-label {
    font-weight: bold;
  }
  div.public-page-container .tab-content .tab-pane {
    color: rgb(82, 95, 127) !important;
  }
  div.public-page-container span.badge {
    border: 2px solid #fff;
    border-radius: 50%;
    cursor: pointer;
    display: inline-block;
    height: 23px;
    margin-right: 5px;
    position: relative;
    width: 23px;
  }
  div.public-page-container  span.badge-vue {
    background-color: #42b883 !important;
  }
  div.public-page-container span.badge.active, div.public-page-container.span.badge:hover {
    border-color: #1d253b;
  }
  div.modal-custom div.modal-dialog {
    width: 45% !important;
  }
  div.theme-row {
    margin: 0px;
    margin-bottom: 15px;
  }
  div.row.theme-row label {
    padding-left: 5px;
  }
  
  div.colors-div {
    padding-top: 5px;
    margin-left: -45px;
  }
  div.flex-div {
    display: flex;
  }
  div.map-image-container {
    margin: 0;
    max-height: 65vh;
    overflow: auto;
    align-content: flex-start;
  }
  div.map-image-content {
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    cursor: pointer;
  }
  div.map-image-content label {
    font-weight: 600;
    text-align: center;
    margin: 8px 0 0;
  }
  div.map-image-content img {
    width: 100%;
    height: 140px;
    object-fit: cover;
    border: 2px solid rgba(0, 0, 0, 0.15);
    border-radius: 6px;
  }
  div.map-image-content.selected img {
    border-color: #e14eca;
    box-shadow: 0 2px 10px rgba(225, 78, 202, 0.45);
  }
  div.map-image-content.selected label {
    color: #e14eca;
  }
  div.map-image-box {
    border: 1px solid #eee;
    border-radius: 5px;
  }
  div.row.public-page-container {
    align-content: flex-start;
  }
  div.row.public-page-container > div.row {
    width: 100%;
    margin-left: 0;
    margin-right: 0;
    align-content: flex-start;
  }
  div.row.public-page-container span.el-range-separator,
  div.row.public-page-container input.el-range-input {
    color: #222a42 !important;
  }
  div.modal-public-page div.modal-footer {
    display: block;
    text-align: center;
  }
  div.modal-public-page a.url-link {
    font-weight: bold;
    color: white !important;
  }
  div.row-pbttom {
    margin-bottom: 30px;
  }
  div.row-marginauto {
    margin: auto;
  }
  input.inputHidden {
    border: none;
    width: 0px;
    background-color: #419ef9;
  }
  i.icon-copy {
    margin-left: 20px;
    cursor: pointer;
  }

  /* ── Embed section (in body) ── */
  .footer-actions {
    width: 100%;
  }
  .embed-body-section {
    width: 100%;
    margin-top: 10px;
    padding: 0 15px;
  }
  .embed-section-body {
    border-top: 1px solid #e8ecf0;
    padding-top: 16px;
  }
  .embed-section {
    flex: 1;
    display: flex;
    flex-direction: column;
    margin-top: 0;
  }
  .btn-embed-toggle {
    flex: 1;                /* stretches to full height of embed-section */
    background: #419ef9;
    border: 1px solid #2b7fd4;
    color: #fff;
    border-radius: 6px;
    padding: 7px 16px;
    font-size: 13px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, box-shadow 0.2s;
    box-shadow: 0 2px 6px rgba(65,158,249,0.35);
  }
  .btn-embed-toggle:hover {
    background: #2b7fd4;
    box-shadow: 0 3px 10px rgba(65,158,249,0.5);
  }
  .embed-panel {
    margin-top: 12px;
    background: #f4f7fb;
    border: 1px solid #d0dce8;
    border-radius: 8px;
    padding: 16px;
  }
  .embed-hint {
    font-size: 12px;
    color: #555e7a;
    margin-bottom: 12px;
  }
  .embed-hint code {
    background: #e0e8f0;
    color: #344675;
    padding: 1px 5px;
    border-radius: 3px;
    font-weight: 600;
  }
  .embed-inputs {
    display: flex;
    align-items: flex-end;
    gap: 12px;
    flex-wrap: wrap;
  }
  .embed-input-group {
    display: flex;
    flex-direction: column;
    flex: 1;
    min-width: 110px;
  }
  .embed-label {
    font-size: 11px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.6px;
    color: #344675;
    margin-bottom: 4px;
  }
  .embed-input-row {
    display: flex;
    align-items: stretch;
    border: 1px solid #b0bec8;
    border-radius: 5px;
    overflow: hidden;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.06);
  }
  .embed-input-row .embed-input {
    flex: 1;
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    padding: 6px 10px;
  }
  .embed-unit-select {
    background: #eef2f7;
    border: none;
    border-left: 1px solid #b0bec8;
    color: #344675;
    font-size: 13px;
    font-weight: 700;
    padding: 0 10px;
    cursor: pointer;
    outline: none;
    min-width: 52px;
    appearance: none;
    -webkit-appearance: none;
    text-align: center;
  }
  .embed-unit-select:focus {
    background: #dce8f5;
  }
  .embed-input {
    background: #fff !important;
    border: 1px solid #b0bec8 !important;
    color: #222a42 !important;
    border-radius: 5px;
    font-size: 13px;
    padding: 6px 10px;
    box-shadow: inset 0 1px 3px rgba(0,0,0,0.06);
  }
  .embed-input:focus {
    border-color: #419ef9 !important;
    outline: none;
    box-shadow: 0 0 0 2px rgba(65,158,249,0.2);
  }
  .embed-input::placeholder {
    color: #aab4c0;
  }
  .btn-generate {
    height: 36px;
    padding: 0 18px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 5px;
    white-space: nowrap;
    flex-shrink: 0;
    background: #344675;
    color: #fff;
    border: none;
    cursor: pointer;
    transition: background 0.2s;
  }
  .btn-generate:hover {
    background: #263157;
  }
  .iframe-result {
    margin-top: 16px;
  }
  .iframe-code-block {
    position: relative;
    background: #1e2740 !important;
    border: 1px solid #344675;
    border-radius: 6px;
    padding: 14px 14px 14px 16px;
    margin-top: 6px;
    overflow: hidden;
  }
  .iframe-code-block pre.iframe-code,
  .iframe-code {
    font-family: 'Courier New', Courier, monospace !important;
    font-size: 12.5px !important;
    color: #7ecf7e !important;
    background: transparent !important;
    margin: 0 !important;
    padding: 0 !important;
    padding-right: 75px !important;
    white-space: pre-wrap !important;
    word-break: break-all !important;
    line-height: 1.6 !important;
    border: none !important;
    box-shadow: none !important;
  }
  .btn-copy {
    position: absolute;
    top: 10px;
    right: 10px;
    background: #344675;
    border: 1px solid #4a5e9a;
    color: #fff;
    border-radius: 5px;
    padding: 5px 13px;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: background 0.2s, color 0.2s;
    display: flex;
    align-items: center;
    gap: 5px;
  }
  .btn-copy:hover {
    background: #263157;
  }
  .btn-copy.copied {
    background: #2dce89;
    border-color: #1aaa6e;
    color: #fff;
  }

  /* Slide transition */
  .embed-slide-enter-active, .embed-slide-leave-active {
    transition: all 0.25s ease;
    overflow: hidden;
  }
  .embed-slide-enter, .embed-slide-leave-to {
    opacity: 0;
    max-height: 0;
    transform: translateY(-6px);
  }
  .embed-slide-enter-to, .embed-slide-leave {
    opacity: 1;
    max-height: 600px;
  }
</style>